function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { getDayOfWeekAndDate } from "@common/services/helpers";
import { LIST_LEVEL_ONE, LIST_LEVEL_TWO, SUBCATEGORIES_LIMIT } from "@config/constants";
var ActiveTitle = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ActiveTitle, PureComponent);
    var _super = _create_super(ActiveTitle);
    function ActiveTitle() {
        _class_call_check(this, ActiveTitle);
        return _super.apply(this, arguments);
    }
    _create_class(ActiveTitle, [
        {
            key: "shouldNavigateToSubcategories",
            value: function shouldNavigateToSubcategories() {
                var subcategories = this.props.category.subcategories;
                var level = this.props.level;
                return level === LIST_LEVEL_ONE && subcategories && (subcategories.length > SUBCATEGORIES_LIMIT || Object.keys(subcategories).length > SUBCATEGORIES_LIMIT);
            }
        },
        {
            key: "shouldNavigateToSubcategoryListing",
            value: function shouldNavigateToSubcategoryListing() {
                var _this_props = this.props, initialNumberOfShows = _this_props.initialNumberOfShows, level = _this_props.level, parentCategoryId = _this_props.parentCategoryId;
                return level === LIST_LEVEL_TWO && parentCategoryId && typeof initialNumberOfShows !== "undefined" && initialNumberOfShows > this.props.showsPerSlide;
            }
        },
        {
            key: "shouldNavigateToListing",
            value: function shouldNavigateToListing() {
                var isActive = this.props.isActive;
                return isActive;
            }
        },
        {
            key: "shouldRenderSimpleLink",
            value: function shouldRenderSimpleLink() {
                var _this_props = this.props, hasStaticTitle = _this_props.hasStaticTitle, initialNumberOfShows = _this_props.initialNumberOfShows, staticLink = _this_props.staticLink;
                return hasStaticTitle && staticLink && typeof initialNumberOfShows !== "undefined" && initialNumberOfShows > this.props.showsPerSlide;
            }
        },
        {
            key: "renderLinkByDate",
            value: function renderLinkByDate() {
                var _this_props = this.props, channel = _this_props.channel, hasSmallerFont = _this_props.hasSmallerFont, i18n = _this_props.i18n, level = _this_props.level, timestamp = _this_props.timestamp, currentDate = _this_props.currentDate;
                var template = null;
                var to = "";
                var dayOfWeek = getDayOfWeekAndDate(currentDate, i18n.days, i18n.months, {
                    today: i18n.common.today,
                    yesterday: i18n.common.yesterday
                });
                var className = "active-title-component".concat(level !== LIST_LEVEL_ONE || hasSmallerFont ? " smaller-font" : "");
                if (this.shouldNavigateToListing()) {
                    to = "/channel/".concat(channel.id, "/listing/").concat(timestamp);
                }
                if (to !== "") {
                    className += " active active-title-component-with-wrapper";
                    template = /*#__PURE__*/ _jsx("div", {
                        className: className,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "active-title-wrapper",
                            children: /*#__PURE__*/ _jsxs(Link, {
                                className: "active-title with-hover",
                                to: to,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "title",
                                        children: dayOfWeek
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-keyboard-arrow-right"
                                    })
                                ]
                            })
                        })
                    });
                } else {
                    template = /*#__PURE__*/ _jsx("div", {
                        className: className,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "title",
                            children: dayOfWeek
                        })
                    });
                }
                return template;
            }
        },
        {
            key: "renderByCategory",
            value: function renderByCategory() {
                var _this_props_category = this.props.category, id = _this_props_category.id, name = _this_props_category.name;
                var _this_props = this.props, hasSmallerFont = _this_props.hasSmallerFont, i18n = _this_props.i18n, level = _this_props.level, parentCategoryId = _this_props.parentCategoryId, route = _this_props.route;
                var template = null;
                var to = "";
                var className = "active-title-component".concat(level !== LIST_LEVEL_ONE || hasSmallerFont ? " smaller-font" : "");
                if (this.shouldNavigateToSubcategories()) {
                    to = "".concat(route, "/").concat(level, "/").concat(id);
                } else if (this.shouldNavigateToSubcategoryListing()) {
                    to = "".concat(route, "/category/").concat(parentCategoryId, "/").concat(level, "/").concat(id, "/listing?back=subcategory");
                } else if (this.shouldNavigateToListing()) {
                    to = "".concat(route, "/").concat(level, "/").concat(id, "/listing");
                }
                if (to !== "") {
                    className += " active active-title-component-with-wrapper";
                    template = /*#__PURE__*/ _jsx("div", {
                        className: className,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "active-title-wrapper",
                            children: /*#__PURE__*/ _jsxs(Link, {
                                className: "active-title",
                                to: to,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "title",
                                        children: name
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "active-title-see-more",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: i18n.common.seeMore
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "icon icon-keyboard-arrow-right"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    });
                } else {
                    template = /*#__PURE__*/ _jsx("div", {
                        className: className,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "title",
                            children: name
                        })
                    });
                }
                return template;
            }
        },
        {
            key: "renderStatic",
            value: function renderStatic() {
                var _this_props = this.props, hasSmallerFont = _this_props.hasSmallerFont, staticLinkTitle = _this_props.staticLinkTitle;
                return /*#__PURE__*/ _jsx("div", {
                    className: "active-title-component".concat(hasSmallerFont ? " smaller-font" : ""),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: staticLinkTitle
                    })
                });
            }
        },
        {
            key: "renderSimpleLink",
            value: function renderSimpleLink() {
                var _this_props = this.props, hasSmallerFont = _this_props.hasSmallerFont, staticLink = _this_props.staticLink, staticLinkTitle = _this_props.staticLinkTitle;
                return /*#__PURE__*/ _jsx("div", {
                    className: "active-title-component active-title-component-with-wrapper active".concat(hasSmallerFont ? " smaller-font" : ""),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "active-title-wrapper",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            className: "active-title with-hover",
                            to: staticLink,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "title",
                                    children: staticLinkTitle
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-keyboard-arrow-right"
                                })
                            ]
                        })
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var template = null;
                var _this_props = this.props, hasStaticTitle = _this_props.hasStaticTitle, hasTitleByDate = _this_props.hasTitleByDate;
                if (this.shouldRenderSimpleLink()) {
                    template = this.renderSimpleLink();
                } else if (hasStaticTitle) {
                    template = this.renderStatic();
                } else if (hasTitleByDate) {
                    template = this.renderLinkByDate();
                } else {
                    template = this.renderByCategory();
                }
                return template;
            }
        }
    ]);
    return ActiveTitle;
}(PureComponent);
export default ActiveTitle;
